<template>
    <section class="login_gradient login_100">
        <div class="container">

            <div class="row">
                <div class="col-sm-12">

                    <div class="flex-adjust">
                        <div class="login-box">
                            <div class="login-logo-wrap text-center">
                                <a href="/">
                                    <img :src="asset('admin/images/logo.png')"  />
                                </a>
                                <small>Admin Panel, Please login to continue</small>
                            </div>
                            <div class="box-white ">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <form @submit.prevent="login">

                                            <div id="success_msg" class="alert alert-success page_alert" style="display: none;">
                                            </div>
                                            <div class="alert alert-success error_msg page_alert" style="display: none;">
                                            </div>

                                            <template v-if="commonErrors && commonErrors.email">
                                                <p class="alert alert-danger"  v-for="item in commonErrors.email">{{item}}</p>
                                            </template>
                                            <template v-if="commonErrors && commonErrors.password">
                                                <p class="alert alert-danger"  v-for="item in commonErrors.password">{{item}}</p>
                                            </template>

                                            <template v-if="errorMessage">
                                                <p class="alert alert-danger">{{errorMessage}}</p>
                                            </template>

                                            <div class="form-group login_input">
                                                <input type="text" class="input_text" v-model="form.email" name="email" id="email" required="required"/>
                                                <label for="email" class="control-label">Email</label>
                                            </div>
                                            <div class="form-group login_input ">
                                                <input type="password" class="input_text" v-model="form.password" name="password" id="password" required="required"/>
                                                <label for="password" class="control-label forgot_input">Password</label>
                                            </div>
                                            <div class="form-group">
                                                <label class="remember-me"><input type="checkbox" v-model="form.remember" id="remember" name="remember"/> Remember Me</label>
                                                <router-link :to="{name: 'ForgotPassword'}" href="" class="forgot pull-right">Forgot Password?</router-link>
                                            </div>
                                            <input type="submit" class="btn btn-primary login" value="LOGIN">
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>


import { mapState, mapActions, mapGetters  } from 'vuex';
import axios from "axios";

export default {
    name: "Login",
    data() {
        return {
            submitted: false,
            form: {
                email: null,
                password: null,
                remember: false
            }
        }
    },
    mounted() {
        localStorage.removeItem("auth");
        localStorage.removeItem("token");
        this.clearAuth();
        this.resetState();
    },
    methods: {
        ...mapActions([
            'setAuth',
            'setLoginLoading',
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'clearAuth',
            'resetState'
        ]),
        login() {
            let self = this;
            this.setLoginLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios
                .post(window.route('login'), this.form, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                .then(({ data }) => {

                    // console.log(data);
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        localStorage.setItem('auth', JSON.stringify(data));
                        localStorage.setItem('token', data.token);
                        self.setAuth(data);
                        self.$router.push({ name: 'dashboard' });
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoginLoading(false);

                });
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage'
        ])
    }
}
</script>


